import Nav from 'scoreboard/components/nav'
import File from 'scoreboard/components/files/file'
import globals from 'scoreboard/components/globals'
import conductor from 'scoreboard/components/conductor'
import appDisplay from 'scoreboard/components/app-display'
import UploadForm from 'scoreboard/components/files/upload-form'
import _ from 'lodash'
import permissions from 'scoreboard/components/permissions'
import DocumentsOverview from './documents-overview'
import config from 'scoreboard/components/config'
import DocumentsGardener from './documents-gardener'
import NoDocumentsView from './no-documents-view'

var DocumentsNav = Nav.extend({
	section: 'files',
	Model: File,
	Gardener: DocumentsGardener,

	className: Nav.prototype.className + ' documents-tree',

	events: _.extend({}, Nav.prototype.events, {
		'click .new': 'addDocument',
		// handle button shown when there are no documents in the org yet
		'click .create-first': 'addDocument'
	}),

	// renders the upload document dialog
	addDocument: function() {
		this._createUploadForm()
	},

	_createUploadForm: function(options = {}) {
		var doc = new File({
			relativeId: conductor.id(),
			organizationId: globals.orgId,
			type: 'file'
		})

		var uploadForm = new UploadForm(_.extend(options, {
			model: doc,
			accept: config.allowedFileTypes,
			instructions: 'documents.upload.drop.document'
		}))

		appDisplay.dialog(uploadForm)
		uploadForm.on('done', function(model) {
			// # Must navigate first or bookmark toggler will pick up the previous document id
			conductor.navigate('files/' + model.id)
			appDisplay.display(new DocumentsOverview({ model: model }))
			this.gardener.tree.select(model.id, { silent: true })
			this.toggleEditViewState(false)
		}.bind(this))
	},

	isEditable: function(orgId) {
		return permissions.documents(orgId)
	},

	_addDomainObject: function(model, relativeId, options) {
		if (!_.get(options, 'maintainSelection')) {
			Nav.prototype._addDomainObject.apply(this, arguments)
		}
	},

	_emptyTree: function() {
		Nav.prototype._emptyTree.apply(this, arguments)
		this.displayNoObjectView()
	},

	displayNoObjectView: function() {
		let view = new NoDocumentsView()
		appDisplay.display(view)
		view.on('done', e => {
			this._createUploadForm({
				files: _.result(e, 'originalEvent.dataTransfer.files')
			})
		})

		view.on('click', () => this._createUploadForm())
	}
})

export default DocumentsNav

DocumentsNav.__filename__ = 'documents/documents-nav.js'
